import apiService from "./apiService";
import AppConstants from "../appConstants";

class ContactService {
    getAllContact(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CONTACT_GETALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_CONTACT_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    // =====================================================================
}

export default new ContactService();
